/**
 * 登录错误码枚举
 */
export var ErrorCodesType;
(function (ErrorCodesType) {
    ErrorCodesType["OAUTH_CODE_ERROR_CODES"] = "OAUTH_CODE_ERROR_CODES";
    ErrorCodesType["IS_NOT_HK_USER_CODES"] = "IS_NOT_HK_USER_CODES";
})(ErrorCodesType || (ErrorCodesType = {}));
